import Vue from "vue";
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: 'home',
      meta: {
        title: '首页',
      },
      component: () => import("../views/index.vue"),
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.document.title = to.meta.title
  }

  if (to.meta.requireAuth) {
    let isLogin = localStorage.getItem('isLogin') == 'true';
    if (isLogin) {
      next()
    } else {
      next({
        path: "/login",
        query: { redirect: to.path }//将跳转的路由path作为参数，登陆成功后跳转到该路由
      })
    }
  } else {
    next();
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

export default router
